import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { I18nModule } from '@spartacus/core'
import { UpdateDispenserAgreementInfoModalComponent } from './update-dispenser-agreement-info-modal.component'

@NgModule({
  declarations: [UpdateDispenserAgreementInfoModalComponent],
  imports: [CommonModule, I18nModule, RouterModule]
})
export class UpdateDispenserAgreementInfoModalModule {}
